import HeaderImage from "../Images/Classroom.png";
import "./Home.css";
import ElfsightReviews from "./GoogleReviews";
import ElfsightChatbot from "./ChatBoxAi";
import { Link } from "react-router-dom";
import { faqData } from "../data/faqData";
import { useEffect, useRef, useState } from "react";
import logger from "../Components/Logger";
import { LevelName } from "../Components/LevelName";

// Tous les émojis ont été prit sur l'Ia pour tous les pages du site web

const EVENTS_CACHE_KEY = "a1app_events_cache";
const CACHE_TTL = 60 * 60 * 1000; // 1 hour
const HOME_PAGE_TITLE = "Tutoring in Parc-Extension | A1 Tutorial";
const HOME_PAGE_DESCRIPTION = "Tutoring in French, math and science, plus homework help, for elementary, high school and CEGEP students. A1 Tutorial, 892 Jean-Talon West, Parc-Extension.";

function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.18 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`.trim()}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

export default function Home({ t }) {
  const [openIndex, setOpenIndex] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const videoRef = useRef(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

useEffect(() => { //modification du code prit depuis la page Admin pour que ça fonctionne sur cette page
  let isMounted = true;
  const loadEvents = async () => {
    setLoading(true);
    try {
      const cached = localStorage.getItem(EVENTS_CACHE_KEY);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_TTL) {
          logger.info("Events loaded from localStorage cache.");
          if (isMounted) setEvents(data);
          return;
        }
      }
      const res = await fetch("/.netlify/functions/getAllEvents");
      const data = await res.json();
    try {
      localStorage.setItem(EVENTS_CACHE_KEY, JSON.stringify({ data, timestamp: Date.now() }));
      logger.info("Events fetched and saved to localStorage cache.");
    } catch (_) {}
      if (isMounted) setEvents(data);
    } catch (err) {
      logger.error(`Erreur chargement événements: ${err.message}`);
    } finally {
      if (isMounted) setLoading(false);
    }
  };
  loadEvents();
  return () => { isMounted = false; };
}, []);
//fin du code réutiliser

const formatDate = (dateString) => { //exemple de code trouver sur : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
  if (!dateString) return "TBD";
  const [year, month, day] = dateString.split('T')[0].split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', {// exemple de code trouver sur : https://blog.logrocket.com/javascript-date-format/
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

  useEffect(() => {
    document.body.style.overflow = selectedEvent ? "hidden" : "auto";
    return () => { document.body.style.overflow = "auto"; };
  }, [selectedEvent]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const keepPlaying = () => {
      if (motion.matches || document.hidden) {
        video.pause();
        return;
      }
      video.muted = true;
      video.loop = true;
      const pending = video.play();
      if (pending && typeof pending.catch === "function") pending.catch(() => {});
    };
    keepPlaying();
    video.addEventListener("ended", keepPlaying);
    document.addEventListener("visibilitychange", keepPlaying);
    motion.addEventListener("change", keepPlaying);
    return () => {
      video.removeEventListener("ended", keepPlaying);
      document.removeEventListener("visibilitychange", keepPlaying);
      motion.removeEventListener("change", keepPlaying);
    };
  }, []);

  useEffect(() => {
    const previousTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute("content");
    const titleEl = document.querySelector("title");
    const keepBrand = () => {
      const withBrand = document.title
        .replace(/Tutorat A1/g, "A1 Tutorial")
        .replace(/Tutoriel A1/g, "A1 Tutorial")
        .replace(/A1 Tutoriel/g, "A1 Tutorial")
        .replace(/A1 Tutorat/g, "A1 Tutorial");
      if (withBrand !== document.title) document.title = withBrand;
    };
    document.title = HOME_PAGE_TITLE;
    if (meta) meta.setAttribute("content", HOME_PAGE_DESCRIPTION);
    const observer = new MutationObserver(keepBrand);
    if (titleEl) observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
    return () => {
      observer.disconnect();
      document.title = previousTitle;
      if (meta && previousDescription) meta.setAttribute("content", previousDescription);
    };
  }, []);

    //permet d'afficher l'évent jusqu'à ce que l'heure de l'évent soit passée
  const activeEvents = events.filter((event) => {
  if (!event.endDate) return true;//explication du .split('t')[0] trouver sur : https://coreui.io/answers/how-to-format-date-as-yyyy-mm-dd-in-javascript/
  const endDateTime = new Date(`${event.endDate.split('T')[0]}T${event.endTime || "23:59"}`);
  return endDateTime >= new Date();
})

  const displayedEvents = activeEvents
  .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))// exemple de code pour trier selon la date trouver sur : https://masteringjs.io/tutorials/fundamentals/sort-by-date et https://dev.to/askyt/sorting-an-array-of-objects-by-date-in-javascript-3pnb
  .slice(0,3);// exemple trouver sur : https://labex.io/fr/tutorials/first-n-elements-28309 

const educationLevels = [
  { id: "Elementary", level: "elementary", tone: "gold", desc: t.ElementaryDesc, points: [t.ElementaryPoint1, t.ElementaryPoint2, t.ElementaryPoint3, t.ElementaryPoint4] },
  { id: "Highschool", level: "highschool", tone: "navy", desc: t.HighSchoolDesc, points: [t.HighSchoolPoint1, t.HighSchoolPoint2, t.HighSchoolPoint3, t.HighSchoolPoint4] },
  { id: "Cegep", level: "cegep", tone: "orange", desc: t.CollegeDesc, points: [t.CollegePoint1, t.CollegePoint2, t.CollegePoint3] },
];

const subjects = [
  { title: t.SubjectFrenchTitle, desc: t.SubjectFrenchDesc, tone: "navy" },
  { title: t.SubjectMathTitle, desc: t.SubjectMathDesc, tone: "gold" },
  { title: t.SubjectScienceTitle, desc: t.SubjectScienceDesc, tone: "orange" },
];

  return (
    <>
      <div className="homePage">
        <section className="hero">
          <img className="hero-still" src={HeaderImage} alt="A1 Tutorial classroom in Parc-Extension, Montreal" />
          {/* Source de la vidéo : https://www.pexels.com/video/teacher-teaching-a-student-8342357/ */}
          <video
            ref={videoRef}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster="/hero-poster.jpg"
            aria-hidden="true"
          >
            <source src="/hero-classroom.mp4" type="video/mp4" />
          </video>
          <div className="hero-shade" aria-hidden="true" />
          <div className="hero-copy">
            <p className="hero-kicker hero-fade hero-fade-1">Parc-Extension, Montreal</p>
            <h1 className="hero-fade hero-fade-1">
              {t.HeroTitle}{" "}
              <span className="hero-place notranslate" translate="no">Parc-Extension</span>
            </h1>
            <p className="hero-lead hero-fade hero-fade-2">{t.HeroSecondary}</p>
            <div className="hero-actions hero-fade hero-fade-3">
              <Link
                to="/courses"
                className="hero-btn hero-btn-solid"
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              >
                See the courses
              </Link>
              <Link
                to="/admission"
                className="hero-btn hero-btn-outline"
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              >
                {t.RegisterNow}
              </Link>
            </div>
          </div>
        </section>

        <ul className="trust-strip">
          <li>
            <a className="notranslate" translate="no" href="tel:+15146906696">
              <span className="trust-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M8 3.8h2.1c.4 0 .8.3.9.7l.8 2.4a1 1 0 0 1-.3 1L10.2 9a12 12 0 0 0 4.8 4.8l1.1-1.3a1 1 0 0 1 1-.3l2.4.8c.4.1.7.5.7.9V16a2 2 0 0 1-2.2 2A14.2 14.2 0 0 1 6 6a2 2 0 0 1 2-2.2Z" />
                </svg>
              </span>
              (514) 690-6696
            </a>
          </li>
          <li>
            <a href="https://www.google.com/maps/place/A1+Tutorial/@45.5254161,-73.6254947,19z/data=!3m2!4b1!5s0x4cc9190a3b6eb73f:0xae19bfdb6d041878!4m6!3m5!1s0x4cc9190a2eb76403:0xbfea07dbf98f19e5!8m2!3d45.5254161!4d-73.624851!16s%2Fg%2F1trc4kwh?entry=ttu&g_ep=EgoyMDI2MTAwNi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
              <span className="trust-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M12 21s6.2-5.2 6.2-10.1A6.2 6.2 0 0 0 5.8 10.9C5.8 15.8 12 21 12 21Z" />
                  <circle cx="12" cy="10.8" r="2.1" />
                </svg>
              </span>
              892 Jean-Talon West
            </a>
          </li>
        </ul>

        {!loading && displayedEvents.length > 0 && (
          <section className="offer-band" aria-label="Now at the centre">
            {displayedEvents.map((event, index) => (
              <Reveal key={event.id} delay={index * 120}>
                <button
                  type="button"
                  className={`offer-card ${index % 2 === 0 ? "is-orange" : "is-gold"}`}
                  onClick={() => setSelectedEvent(event)}
                >
                  <span className="offer-light" aria-hidden="true" />
                  <span className="offer-ribbon"><span>Special offer</span></span>
                  <span className="offer-date">{formatDate(event.startDate)}</span>
                  <h2>{event.title}</h2>
                  <p>{event.description}</p>
                  <span className="offer-more">See more</span>
                </button>
              </Reveal>
            ))}
          </section>
        )}

        <section className="homeGroupSection">
          <h2 className="home-heading">{t.SectionDivider}</h2>
          <p className="home-lead">{t.SubtitleInfo}</p>
          <div className="homeGroupGrid">
            {educationLevels.map((item, index) => (
            <Reveal key={item.id} delay={index * 120}>
            <div className={`homeGroupCard tone-${item.tone}`}>
              <Link
                to={`/courses#${item.id}`}
                className="homeCardLink"
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              >
                <h3><LevelName level={item.level} /></h3>
                <p className="homeGroup">{item.desc}</p>
                <ul>
                  {item.points.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                  <span className="subjectHover">Click to see the subjects</span>
                </ul>
              </Link>
            </div>
            </Reveal>
          ))}
          </div>
        </section>
        <section className="homeSubjectsSection">
          <h2 className="home-heading">{t.SubjectsHeading}</h2>
          <div className="homeSubjectsGrid">
            {subjects.map((subject, index) => (
              <Reveal key={subject.title} delay={index * 120}>
                <Link to="/courses" className={`homeSubjectCard tone-${subject.tone}`}>
                  <h3>{subject.title}</h3>
                  <p>{subject.desc}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </section>
      </div>

      <section className="reviewsSection">
        <div className="reviewsContainer">
          <h2 className="reviewsTitle">{t.GoogleReviewsSubtitle}</h2>
          <ElfsightReviews />
        </div>
      </section>
      <div className="ChatboxAi">
        <ElfsightChatbot />
      </div>
      <div className="faq-container">
        <div className="title">
          <h2>{t.FaqHeading}</h2>
        </div>

        {faqData.map((item, index) => (
          <Reveal key={index} delay={index * 80}>
          <div className={`faq ${openIndex === index ? "active" : ""}`}>
            <button className="question" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index}>
              <h2>{item.question}</h2>
              <span className="icon">{openIndex === index ? "−" : "+"}</span>
            </button>

            <div className={`answer-wrapper ${openIndex === index ? "open" : ""}`}>
              <p className="content">{item.answer}</p>
            </div>
          </div>
          </Reveal>
        ))}
      </div>

      <section className="home-join">
        <Reveal className="home-join-card">
          <span className="home-join-light" aria-hidden="true" />
          <h2>{t.ReadyToJoin}</h2>
          <p>{t.ContactUsToEnroll}</p>
          <div className="home-join-actions">
            <Link
              to="/admission"
              className="home-join-primary"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              {t.RegisterNow}
            </Link>
            <a className="home-join-call notranslate" translate="no" href="tel:+15146906696">
              (514) 690-6696
            </a>
          </div>
          <ul className="home-join-chips">
            <li className="notranslate" translate="no">Parc-Extension</li>
            <li className="home-join-levels">
              <span>{t.French}</span>
              <span className="home-join-dot" aria-hidden="true">·</span>
              <span>{t.Math}</span>
              <span className="home-join-dot" aria-hidden="true">·</span>
              <span>{t.Science}</span>
            </li>
            <li className="home-join-levels">
              <LevelName level="elementary" />
              <span className="home-join-dot" aria-hidden="true">·</span>
              <LevelName level="highschool" />
              <span className="home-join-dot" aria-hidden="true">·</span>
              <LevelName level="cegep" />
            </li>
          </ul>
        </Reveal>
      </section>

      {selectedEvent && ( //aide de l'ia pour le css et les classname
        <div className="modal-overlayHome" onClick={() => setSelectedEvent(null)}>
          <div className="modal-contentHome" onClick={(e) => e.stopPropagation()}>
            <div className="modal-headerEvent">
              <h3>{selectedEvent.title}</h3>
              <button className="close-button" onClick={() => setSelectedEvent(null)}> &times;</button> </div>
            <div className="modal-body-content">
              <p className="event-full-desc">{selectedEvent.description}</p>
              {(selectedEvent.locationName || selectedEvent.address) && ( 
              <div className="event-location-box">
                <div className="detail-itemlo">
                  <span className="detail-labello">Location :</span>
                  <div className="detail-value-wrapperlo">
                    <div className="location-info-wrapper">
                      <span className="detail-valuelo">{selectedEvent.locationName}</span>
                      {selectedEvent.address && ( <div className="location-address-sub"> {selectedEvent.address}</div> )}
                    </div>
                  </div>
                </div>
              </div>
            )}
              <div className="event-details-box">
                <div className="detail-item">
                  <span className="detail-label">Event Date Start : </span>
                  <div className="detail-value-wrapper">
                    <span className="detail-icon">📅</span>
                    <span className="detail-value">
                      {formatDate(selectedEvent.startDate)}
                      {selectedEvent.startTime && ( <div className="detail-time">at {selectedEvent.startTime}</div> )}
                    </span>
                  </div>
                </div>
                <div className="detail-divider"></div>
                <div className="detail-item">
                  <span className="detail-label">Event Date End : </span>
                  <div className="detail-value-wrapper">
                    <span className="detail-icon">📅</span>
                    <span className="detail-value">
                      {formatDate(selectedEvent.endDate)}
                      {selectedEvent.endTime && (<div className="detail-time">at {selectedEvent.endTime}</div>)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footerEvent">
              <button className="btn-cancel"onClick={() => setSelectedEvent(null)}> <span>Closes</span></button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
